import axios from 'axios'
const baseurl = process.env.REACT_APP_API_URL

export const sendOtp = async data => {
  try {
    const response = await axios({
      method: 'post',
      url: baseurl + `/sendOtp`,
      data: data
    })
    return response.data
  } catch (error) {
    return {
      status: 'error',
      message: 'Something went wrong. Please try again.'
    }
  }
}
export const resendOtp = async data => {
  try {
    const response = await axios({
      method: 'post',
      url: baseurl + `/resendOtp`,
      data: data
    })
    return response.data
  } catch (error) {
    return {
      status: 'error',
      message: 'Something went wrong. Please try again.'
    }
  }
}
export const verifyOtp = async (mobile, otp, sessionId) => {
  try {
    const response = await axios({
      method: 'post',
      url: baseurl + `/verifyOtp`,
      data: {
        mobile: mobile,
        otp: otp,
        sessionId: sessionId
      }
    })
    return response.data
  } catch (error) {
    console.log(error)
    return {
      status: 'error',
      message: 'Something went wrong. Please try again.'
    }
  }
}
